<template>
  <div class="Footer-box">
    <div class="container">
      <div class="contact-section">
        <div class="contact-line">{{ $t('footer.contact') }}：021-62338909</div>
      </div>
    </div>

    <div class="footer-bottom">
      <div class="container">
        <div class="footer-info">
          <span>{{ $t('footer.companyName') }}</span>
          <span>realvalere@realvalere.com</span>
          <span>{{ $t('footer.address') }}</span>
        </div>
        <div class="footer-icp">
          {{ $t('footer.icp') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer"
}
</script>

<style scoped lang="less">
.Footer-box{
  width: 100%;
  background: #0A1428;
  position: relative;
  padding: 40px 0 20px;
  box-sizing: border-box;

  .container {
    max-width: 1440px;
    width: 90%;
    margin: 0 auto;
  }

  .contact-section {
    margin-top: 30px;
    .contact-line {
      font-size: 18px;
      color: #fff;
    }
  }

  .footer-bottom {
    width: 100%;
    border-top: 1px solid rgba(255,255,255,0.1);
    margin-top: 50px;
    padding: 30px 0 20px;
    box-sizing: border-box;

    .footer-info {
      display: flex;
      gap: 40px;
      margin-bottom: 20px;
      flex-wrap: wrap;
      span {
        font-size: 16px;
        color: rgba(255,255,255,0.7);
      }
    }
    .footer-icp {
      font-size: 14px;
      color: rgba(255,255,255,0.5);
    }
  }
}
</style>